import React from 'react';
import { breadcrumbsParams, getBreadcrumbs } from 'app/area/shared/codetable/breadcrumbs';
import { LinkCodesList } from './components/link-codes-list';
import { UserInfo } from 'app/types-shared';

interface LinkCodesProps {
  userInfo?: UserInfo;
  params: breadcrumbsParams;
  route: any;
}

export function LinkCodes({ 
  userInfo: { access: { adminPanel: { codetable: { linkSubset } } } },
  params, route
}: LinkCodesProps) {
  const breadcrumbs = getBreadcrumbs(params);

  return <LinkCodesList breadcrumbs={breadcrumbs} route={route} linkSubset={linkSubset} />;
}
